import { registerFlow } from '../../../core/flow-register';
import { makeFlow } from '../front-office-mf-contributory/index';
import { IRAAccountTypes } from '../front-office-mf-contributory/loaders';

registerFlow(
  makeFlow('roth-ira', {
    toIRAAccountType: IRAAccountTypes.ROTH
  })
);
